import { useEffect, useState } from 'react';
import axios from '../../api/axiosInstance';
import Loader from './components/Loader';
import ErrorBox from './components/ErrorBox';

export default function ManageFlashes() {
  const search = new URLSearchParams(window.location.search);
  const businessId = search.get('business_id');
  const [flashes, setFlashes] = useState([]);
  const [state, setState] = useState('loading');

  useEffect(() => {
    setState('loading');
    axios
      .get('/dashboard/flashes', { params: { business_id: businessId } })
      .then(({ data }) => {
        setFlashes(data);
        setState('ready');
      })
      .catch(() => setState('error'));
  }, [businessId]);

  if (state === 'loading') return <Loader />;
  if (state === 'error') return <ErrorBox message="Failed to load flashes." />;

  return (
    <div className="mx-auto max-w-5xl space-y-6 p-6">
      <h1 className="text-xl font-semibold">Manage Flashes</h1>

      {flashes.length === 0 ? (
        <p className="text-gray-600">No flashes submitted yet.</p>
      ) : (
        <ul className="space-y-3">
          {flashes.map((f) => (
            <li
              key={f.id}
              className="flex items-center justify-between rounded-md border p-4"
            >
              <span>{f.caption || 'Untitled flash'}</span>
              {/* Re-order buttons reserved for drag-n-drop – minimal impl */}
              <button className="rounded bg-gray-200 px-2 py-1 text-xs">
                ↑
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
